import { React, useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import "./Login.css";
import { isEmpty, isNullOrUndefined } from "utils/validationUtil";
import { authenticate } from "app/services/auth.service";

import { Button, TextField, Alert, Collapse, IconButton, InputAdornment } from "@mui/material";
import {
  Close as CloseIcon,
  Visibility as VisibilityOutlinedIcon,
  VisibilityOff as VisibilityOffOutlinedIcon,
} from "components/icons";

import { AuthLayout } from "./AuthLayout";
import { getLandingRoute, readSessionIsUserLoggedIn } from "app/services/app.state.service";

export const Login = () => {
  const [email, setEmail] = useState(); // username is email in our application
  const [password, setPassword] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("info"); // "error" or "warning" or "info" or "success"
  const [searchParams] = useSearchParams();
  /**
   * token and isLogin are session state variables
   * @param {*} props
   */

  // The axios error handler redirects here with ?sessionExpired=true after a 401.
  useEffect(() => {
    if (searchParams.get("sessionExpired") === "true") {
      setMessage("Session expired, please log in again.");
      setSeverity("warning");
      setOpen(true);
    }
  }, [searchParams]);

  const loginClickHandler = async (e) => {
    e.preventDefault();

    if (
      isNullOrUndefined(email) ||
      email?.trim() === "" ||
      isNullOrUndefined(password) ||
      password?.trim() === ""
    ) {
      window.alert("Username or password can not be empty");
      return;
    }

    await authenticate(email, password)
      .then(() => {
        var isLogin = readSessionIsUserLoggedIn();
        // Everything successful, go to home page
        if (!isEmpty(isLogin) && (isLogin === true || isLogin === "true")) {
          window.location.replace(getLandingRoute());
        }
      })
      .catch((error) => {
        setMessage(
          <>
            <p>
              <strong>Wrong Credentials</strong>
            </p>{" "}
            <ul>
              <li>Your email address and password does not match.</li>
            </ul>
          </>
        );
        setOpen(true);
        setSeverity("warning");
        clearAction();
      });
  };

  const clearAction = () => {
    setTimeout(() => {
      setMessage("");
      setOpen(false);
    }, 2500);
  };

  return (
    <AuthLayout>
      <Collapse in={open}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          severity={severity}
          sx={{ mt: 3 }}
        >
          {message}
        </Alert>
      </Collapse>

      <form className="login-form" onSubmit={loginClickHandler} noValidate>
        <div className="login-field">
          <label className="login-label" htmlFor="email">
            Email address
          </label>
          <TextField
            variant="outlined"
            required
            fullWidth
            id="email"
            name="email"
            autoComplete="email"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="login-field">
          <div className="login-label-row">
            <label className="login-label" htmlFor="password">
              Password
            </label>
            <Link className="login-link" to="/forgot-password">
              Forgot password?
            </Link>
          </div>
          <TextField
            variant="outlined"
            required
            fullWidth
            name="password"
            type={showPassword ? "text" : "password"}
            id="password"
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="login-reveal"
                      aria-label={showPassword ? "Hide password" : "Show password"}
                      onClick={() => setShowPassword((shown) => !shown)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />
        </div>
        <Button type="submit" fullWidth variant="contained" color="primary" className="login-submit">
          Sign in
        </Button>
      </form>

      <p className="login-footnote">Accounts are set up by your HRMS administrator.</p>
    </AuthLayout>
  );
};
